import { render, staticRenderFns } from "./ReadInstructions.vue?vue&type=template&id=25f1addd&scoped=true&"
import script from "./ReadInstructions.vue?vue&type=script&lang=js&"
export * from "./ReadInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ReadInstructions.vue?vue&type=style&index=0&id=25f1addd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f1addd",
  null
  
)

export default component.exports